// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jl-1";
export var messageSideRight = "_jl-2";
export var subscribeToBackInStockBubbleContainer = "_jl-0";